// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Edit: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 53"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M52.5 14c-.1-.6-.6-1.2-1-1.8L40.9 1.6c-1.3-1.3-3.7-1.4-5 0L7.4 30.2.5 51.1c-.1.4 0 .7.2 1 .2.2.4.3.7.3h.3l21.2-6.3.2-.1 21.2-21.4 7.2-7.3c.9-1 1.2-2.1 1-3.3zM19.3 40l1.2 3.9-16.3 4.8 5.3-16.1 3.5.8V40h6.3zm-8.1-9.8l18.1-18L41 24 22.8 42.3l-1.5-5.1h-5.7v-6l-4.4-1zm38.3-14.9L42.9 22 31.2 10.2l6.6-6.6c.3-.3.8-.3 1.1 0l10.7 10.7c.2.2.3.7-.1 1z"/></svg>;
};

export default React.memo(Edit);
